import Vue from 'vue'
import { mapMutations, mapGetters } from 'vuex'
import lodash from 'lodash'
import AccessManager from '@/core/access'

//全局mixin对象
const globalMixin = {
    methods: {
        /**
         * 是否显示遮罩
         * @param {*} isShow    是否显示
         */
        showMask(isShow) {
            this.setLoadingStatus(isShow);
        },
        
        /**
         * 根据组件id查找组件对象（vue ref）
         * @param {*} id    组件id
         */
        getControl(id) {
            return this.$refs[id];
        },
        /**
         * 拷贝对象
         * @param {*} obj   要进行copy的对象
         */
        copyObject(obj) {
            if (obj == null) return obj;
            return lodash.cloneDeep(obj);
        },
        /**
         * 合并对象
         * @param {*} obj1 
         * @param {*} obj2 
         */
        mergeObject(obj1, obj2) {
            return lodash.merge(obj1, obj2);
        },
        /**
         * 合并对象，将空字符串设置为null
         * @param {*} obj1 
         * @param {*} obj2 
         */
        mergeIgnorEmpty(obj1, obj2) {
            return lodash.mergeWith(obj1, obj2, function(objValue, srcValue) {
                if (srcValue === '') {
                    return null;
                }
            });
        },
        /**
         * 判读用户是否有权限
         * @param {*} permCode    权限字
         */
        checkPermCodeExist(permCode) {
            if (this.getUserInfo.permCodeSet != null) {
                return this.getUserInfo.permCodeSet.has(permCode);
            }
            else {
                return this.getUserInfo.isAdmin;
            }
        },
        /**
         * @methods
         * @param {*} value 
         * @param {*} type 
         */
        parseParams (value, type = 'string') {
            if (value == null) return value;
            switch (type) {
                case 'integer': return Number.parseInt(value);
                case 'float': return Number.parseFloat(value);
                case 'boolean': return (value === 'true' || value);
                default: return String(value);
            }
        },
        parseArrayParams (value, type = 'string') {
            if (Array.isArray(value)) {
                return value.map((item) => {
                    switch (type) {
                        case 'integer': return Number.parseInt(item);
                        case 'float': return Number.parseFloat(item);
                        case 'boolean': return (item === 'true' || item);
                        default: return String(item);
                    }
                });
            } else {
                return [];
            }
        },
        ...mapMutations(['setLoadingStatus'])
    },
    computed: {
        ...mapGetters(['getUserInfo'])
    }
}

Vue.mixin(globalMixin);

export const globalConfig = {
    httpOption: {
        showMask: true,
        showError: true
    },
    axiosOption: {

    },
    confirmOption: {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
    }
};


// WEBPACK FOOTER //
// ./src/core/config/global.js